export function submitAddCustomer()
{
    return({
        type:"SUBMIT_ADD_CUSTOMER"
    })
}